import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  Row,
  Stack,
  Tab,
  Tabs,
  ToggleButton,
  ToggleButtonGroup,
} from "react-bootstrap";
import SearchableSingleSelectDropdown from "../../../common/SearchableDropdown";
import AppointmentActionsDropdown from "../../../common/AppointmentActionsDropdown";
import AccordionComponent from "../../../common/Accordion";
import DataTable from "../../../common/DataTable";
import InvoiceCancel from "./components/InvoiceCancel";
import FloatingLabelMonthPicker from "../../../common/MonthPicker";
import { CLIENT_INVOICE_HEADER } from "../ManageInvoice/actions/constants";
import {
  getInvoiceReportByClientQme,
  getInvoiceReportByClientQmeCase,
  getInvoiceReportByClientRole,
  getInvoiceReportByClientRoleCase,
  getInvoiceReportByClientUser,
  getInvoiceReportByClientUserCase,
  getInvoiceReportSummary,
  getInvoiceReportSummaryCount,
} from "../../../services/InvoiceReportsApi";
import {
  downloadClientInvoice,
  downloadUserInvoice,
  downloadRoleInvoice,
} from "../../../services/InvoiceAPI";
import {
  INVOICE_REPORTS_CODES,
  INVOICE_STATUS,
} from "../../../common/Constant";
import {
  getInvoiceStatusList,
  getInvoiceTeamClientList,
} from "../../../services/InvoiceAPI";
import { toYearMonth } from "../../../utils/dateUtils";
import SearchableMultiSelectDropdown from "../../../common/SearchableMultiSelectDropdown";
import InvoiceReportDataTable from "./components/InvoiceReportDataTable";
import { FaSleigh } from "react-icons/fa";
import UploadStatusFloatingIcon from "../../../common/UploadStatusFloatingIcon";
import { DropdownWithTooltip } from "../../../common/DropdownWithTooltip";

interface TabConfig {
  key: string;
  title: string;
  summaryApi: (payload: any) => Promise<any>;
  listApi: (payload: any) => Promise<any>;
  detailApi: (payload: any) => Promise<any>;
}

const InvoiceReportDashboard = () => {
  const [selectedInvoiceType, setSelectedInvoiceType] = useState("Generated");
  const [generatedCount, setGeneratedCount] = useState(4);
  const [canceledCount, setCanceledCount] = useState(10);

  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [nestedRowsData, setNestedRowsData] = useState<any[]>([]);
  const [selectedViewData, setSelectedViewData] = useState<any[]>([]);
  const [activeTab, setActiveTab] = useState<string>("Client");
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [activeFilter, setActiveFilter] = useState("All");
  const [activeCard, setActiveCard] = useState<string>(
    INVOICE_REPORTS_CODES.GENERATE,
  );
  const [activeSubCard, setActiveSubCard] = useState<string>("");

  const [totalRows, setTotalRows] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(15);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [sortColumn, setSortColumn] = useState<string>("");
  const [sortOrder, setSortOrder] = useState<"ASC" | "DESC">("DESC");
  const [drawerTitle, setDrawerTitle] = useState("");
  const [showActionDrawer, setShowActionDrawer] = useState(false);
  const [selectedAction, setSelectedAction] = useState<string | number>("");
  const [statusOptions, setStatusOptions] = useState<any[]>([]);
  const [teamsOptions, setTeamsOptions] = useState<any[]>([]);
  const [month, setMonth] = useState<Date | null>(new Date());
  const [status, setStatus] = useState<(string | number)[]>([]);
  const [teams, setTeams] = useState<string | number | null>(null);
  const [teamclient, setTeamClient] = useState<string | number | null>(null);
  const [tableKey, setTableKey] = useState<string>(`table-${Date.now()}`);
  const [resetTableTrigger, setResetTableTrigger] = useState(false);
  const [clientInvoiceSummaries, setClientInvoiceSummaries] = useState<any[]>(
    [],
  );
  const [roleInvoiceSummaries, setRoleInvoiceSummaries] = useState<any[]>([]);
  const [userInvoiceSummaries, setUserInvoiceSummaries] = useState<any[]>([]);

  const [totalGeneratedInvoiceCount, setTotalGeneratedInvoiceCount] =
    useState<number>(0);

  const [totalGeneratedInvoiceValue, setTotalGeneratedInvoiceValue] =
    useState<number>(0);

  const [totalAmendedInvoiceCount, setTotalAmendedInvoiceCount] =
    useState<number>(0);

  const [totalAmendedInvoiceValue, setTotalAmendedInvoiceValue] =
    useState<number>(0);

  const [totalCancelledInvoiceCount, setTotalCancelledInvoiceCount] =
    useState<number>(0);

  const [totalCancelledInvoiceValue, setTotalCancelledInvoiceValue] =
    useState<number>(0);

  const [accordianKey, setAccordianKey] = useState<string | null>("0");
  const [downloadStatuses, setDownloadStatuses] = useState<any>({});
  const latestRequestRef = useRef(0);
  const latestRequestCountRef = useRef(0);

  const getHeaders = () => {
    const headers = [...CLIENT_INVOICE_HEADER];
    if (activeTab === "Client") {
      headers[1] = { ...headers[1], label: "Task" };
    }

    return headers;
  };

  const tabConfigs: TabConfig[] = [
    {
      key: "Client",
      title: "Client",
      summaryApi: getInvoiceReportSummary,
      listApi: getInvoiceReportByClientQme,
      detailApi: getInvoiceReportByClientQmeCase,
    },
    {
      key: "Role",
      title: "Role",
      summaryApi: getInvoiceReportSummary,
      listApi: getInvoiceReportByClientRole,
      detailApi: getInvoiceReportByClientRoleCase,
    },
    {
      key: "User",
      title: "User",
      summaryApi: getInvoiceReportSummary,
      listApi: getInvoiceReportByClientUser,
      detailApi: getInvoiceReportByClientUserCase,
    },
  ];

  const isMultiSelect = selectedRows?.length > 1;
  const [showInvoiceTab, setShowInvoiceTab] = useState(false);

  const [allOptions, setAllOptions] = useState<any[]>([]);

  const getCurrentTabConfig = () => {
    return tabConfigs.find((tab) => tab.key === activeTab) || tabConfigs[0];
  };

  const fetchInvoiceFilters = async () => {
    try {
      const [statusRes, teamClientRes] = await Promise.all([
        getInvoiceStatusList(),
        getInvoiceTeamClientList(),
      ]);

      setStatusOptions(statusRes || []);
      setTeamsOptions(teamClientRes || []);
    } catch (error) {
      console.error("Error fetching invoice filters:", error);
    }
  };

  useEffect(() => {
    fetchInvoiceFilters();
  }, []);

  // Fetch data based on active tab
  const fetchInvoiceSummary = async () => {
    const requestId = ++latestRequestRef.current;
    const currentTab = getCurrentTabConfig();
    const summaryPayload = {
      yearMonth: toYearMonth(month),
      // invoiceLineItemStatusIds: status?.join(",") || "",
      teamId: Number(teamclient) || null,
      clientId: Number(teams) || null,
      searchText: searchQuery?.trim(),
      invoiceStatus: activeCard,
    };

    try {
      setLoading(true);
      const data = await currentTab.summaryApi(summaryPayload);

      if (requestId !== latestRequestRef.current) return;

      switch (activeTab) {
        case "Client":
          setClientInvoiceSummaries(data || []);
          setTableKey(`table-${Date.now()}`);
          break;
        case "Role":
          setRoleInvoiceSummaries(data || []);
          setTableKey(`table-${Date.now()}`);
          break;
        case "User":
          setUserInvoiceSummaries(data || []);
          setTableKey(`table-${Date.now()}`);
          break;
        default:
          setClientInvoiceSummaries(data || []);
          setTableKey(`table-${Date.now()}`);
      }
    } catch (error) {
      console.error(
        `Failed to fetch ${activeTab.toLowerCase()} invoice summary:`,
        error,
      );
    } finally {
      if (requestId === latestRequestRef.current) {
        setLoading(false);
      }
    }
  };

  const getCurrentInvoiceData = () => {
    switch (activeTab) {
      case "Client":
        return clientInvoiceSummaries;
      case "Role":
        return roleInvoiceSummaries;
      case "User":
        return userInvoiceSummaries;
      default:
        return clientInvoiceSummaries;
    }
  };

  const getListApi = () => {
    return getCurrentTabConfig().listApi;
  };

  const getDetailApi = () => {
    return getCurrentTabConfig().detailApi;
  };

  const getInvoiceReportCountData = async (query: string = "") => {
    const requestId = ++latestRequestCountRef.current;
    try {
      const trimmedQuery = query?.trim();

      const payload = {
        yearMonth: toYearMonth(month),
        clientId: Number(teams) || null,
        searchText: trimmedQuery,
      };

      const response = await getInvoiceReportSummaryCount(payload);

      if (requestId !== latestRequestCountRef.current) return;

      if (response) {
        setTotalGeneratedInvoiceCount(
          response.total_Generated_Invoice_Count ?? 0,
        );
        setTotalGeneratedInvoiceValue(
          response.total_Generated_Invoice_Value ?? 0,
        );

        setTotalAmendedInvoiceCount(response.total_Amended_Invoice_Count ?? 0);
        setTotalAmendedInvoiceValue(response.total_Amended_Invoice_Value ?? 0);

        setTotalCancelledInvoiceCount(
          response.total_Cancelled_Invoice_Count ?? 0,
        );
        setTotalCancelledInvoiceValue(
          response.total_Cancelled_Invoice_Value ?? 0,
        );
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      if (requestId === latestRequestCountRef.current) {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchInvoiceSummary();
  }, [activeTab, month, teams, status, searchQuery, activeCard]);

  useEffect(() => {
    getInvoiceReportCountData();
  }, [activeTab, month, teams, status, searchQuery]);

  const debounce = (func: Function, delay: number) => {
    let timer: NodeJS.Timeout;
    return (...args: any[]) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  };

  const handleAccordionSelect = (key: string | null) => {
    if (accordianKey === key) {
      return;
    }
    setAccordianKey(key || "0");
  };

  const configurationAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item) => ({ ...item }))}
      activeKey={accordianKey}
      onSelect={handleAccordionSelect}
    />
  );

  // const handleRowSelect = (data: {
  //   selectedRows: any[];
  //   level0InvoiceId?: any;
  //   nestedRows?: any;
  // }) => {
  //   console.log(
  //     data.nestedRows,
  //     "nestedRows",
  //     data.selectedRows,
  //     "selectedRows",
  //     data.level0InvoiceId,
  //     "level0InvoiceId",
  //   );

  //   setSelectedRows(data.selectedRows);
  //   setNestedRowsData(data.nestedRows);

  //   if (!data.selectedRows?.length || !data.nestedRows?.length) {
  //     setAllOptions([]);
  //     return;
  //   }

  //   // Step 1: Get mainParentId
  //   const mainParentId = data.selectedRows[0]?.mainParentId;

  //   // Step 2: Find matched invoice
  //   const matchedInvoice = data.nestedRows.find(
  //     (invoice: any) => invoice.id === mainParentId,
  //   );

  //   if (!matchedInvoice) {
  //     setAllOptions([]);
  //     return;
  //   }

  //   const level1Children = matchedInvoice.children || [];

  //   // Step 3: Check if all expanded
  //   const allExpanded =
  //     level1Children.length > 0 &&
  //     level1Children.every((child: any) => child.isExpanded === true);

  //   // Step 4: Set Dropdown Label
  //   if (allExpanded) {
  //     setAllOptions([{ value: "Cancel Invoice", label: "Cancel Invoice" }]);
  //   } else {
  //     setAllOptions([
  //       {
  //         value: "Cancel Invoice Line Item",
  //         label: "Cancel Invoice Line Item",
  //       },
  //     ]);
  //   }
  // };

  const handleRowSelect = (data: {
    selectedRows: any[];
    level0InvoiceId?: any;
    nestedRows?: any;
  }) => {
    setSelectedRows(data.selectedRows);
    setNestedRowsData(data.nestedRows);

    if (!data.selectedRows?.length || !data.nestedRows?.length) {
      setAllOptions([]);
      return;
    }

    const mainParentId = data.selectedRows[0]?.mainParentId;

    // Find level 0 invoice
    const matchedInvoice = data.nestedRows.find(
      (invoice: any) => invoice.id === mainParentId,
    );

    if (!matchedInvoice) {
      setAllOptions([]);
      return;
    }

    const allLevel2Children =
      matchedInvoice.children?.flatMap(
        (level1: any) => level1.children || [],
      ) || [];

    const totalLineItems = allLevel2Children.length;
    const selectedCount = data.selectedRows.length;

    if (selectedCount === totalLineItems) {
      setAllOptions([{ value: "Cancel Invoice", label: "Cancel Invoice" }]);
    } else {
      setAllOptions([
        {
          value: "Cancel Invoice Line Item",
          label: "Cancel Invoice Line Item",
        },
      ]);
    }
  };

  const handleDownloadProgress = async (
    id: string,
    downloadFn: () => Promise<any>,
    fileName: string = "File.zip",
  ) => {
    setDownloadStatuses((prev: any) => ({
      ...prev,
      [id]: { fileName, progress: 0, isUploading: true },
    }));

    let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      if (progress >= 90) return;
      setDownloadStatuses((prev: any) => ({
        ...prev,
        [id]: { ...prev[id], progress },
      }));
    }, 300);

    try {
      await downloadFn();
      clearInterval(interval);
      setDownloadStatuses((prev: any) => ({
        ...prev,
        [id]: { ...prev[id], progress: 100, isUploading: false },
      }));
      setTimeout(() => {
        setDownloadStatuses((prev: any) => {
          const updated = { ...prev };
          delete updated[id];
          return updated;
        });
      }, 2000);
    } catch (error) {
      console.error("Download error:", error);
      clearInterval(interval);
      setDownloadStatuses((prev: any) => ({
        ...prev,
        [id]: { ...prev[id], isUploading: false },
      }));
    }
  };

  const handleAction = (action: string, row: any) => {
    setLoading(true);
    setSelectedViewData(row);
    if (activeTab == "Client") {
      handleDownloadProgress(
        row?.caseRecordDetailsId,
        () => downloadClientInvoice(row?.invoiceId),
        row?.fileName,
      );
    } else if (activeTab == "User") {
      handleDownloadProgress(
        row?.caseRecordDetailsId,
        () => downloadUserInvoice(row?.invoiceId),
        row?.fileName,
      );
    } else {
      handleDownloadProgress(
        row?.caseRecordDetailsId,
        () => downloadRoleInvoice(row?.invoiceId),
        row?.fileName,
      );
    }
    setLoading(false);
  };

  const handleCardClick = (filter: string) => {
    const current = 1;
    const perPage = 15;
    setActiveCard(filter);
    setCurrentPage(current);
    setItemsPerPage(perPage);
    setSortColumn("");
    setSortOrder("DESC");
  };

  const handleTabChange = (key: string | null) => {
    if (key) {
      setActiveTab(key);
      resetTable();
    }
  };

  const handleInputChange = debounce((value: string) => {
    if (value?.length >= 3 || value?.length === 0) {
      setClientInvoiceSummaries([]);
      setRoleInvoiceSummaries([]);
      setUserInvoiceSummaries([]);
      setSearchQuery(value);
      setCurrentPage(1);
      setTableKey(`table-${Date.now()}`);
    }
  }, 300);

  const handlecloseActionDrawer = async (action?: any) => {
    setShowActionDrawer(false);
    if (action === "Save") {
      resetAllData();
    }
  };

  const handleActionChange = (value: string | number) => {
    setSelectedAction(value);
    if (value === "Cancel Invoice" || value == "Cancel Invoice Line Item") {
      setShowActionDrawer(true);
      setDrawerTitle(value);
    }
  };

  const handleResetFilters = () => {
    if (searchQuery) {
      resetAllData();
    }
  };

  const resetTable = () => {
    setMonth(new Date());
    setStatus([]);
    setTeams(null);
    setTeamClient(null);
    setCurrentPage(1);
    setResetTableTrigger((prev) => !prev);
    resetAllData();
  };

  const resetAllData = () => {
    setTableKey(`table-${Date.now()}`);
    setClientInvoiceSummaries([]);
    setRoleInvoiceSummaries([]);
    setUserInvoiceSummaries([]);
    setSelectedRows([]);
    setNestedRowsData([]);
    setSelectedAction("");
    setSearchQuery("");
    if (inputRef.current) {
      inputRef.current.value = "";
    }
    getInvoiceReportCountData();
    fetchInvoiceSummary();
  };

  const handleClose = () => {
    setShowInvoiceTab(false);
  };

  return (
    <>
      <UploadStatusFloatingIcon
        uploadStatuses={downloadStatuses}
        isUpload={false}
        onCancelUpload={(id) => {
          setDownloadStatuses((prev: any) => {
            const updated = { ...prev };
            delete updated[id];
            return updated;
          });
        }}
      />
      <div className="breadcrumbg breadcrumbgNew pb-0 pt-1">
        <Container fluid className="px-5">
          <Stack direction="horizontal" gap={2}>
            <Row className="pt-0 fade-in-left">
              <Col>
                <h4>Invoice Reports</h4>
              </Col>
            </Row>
          </Stack>
        </Container>
      </div>
      <Container fluid className="px-5">
        <div className="main_wrapper_section pills_wrapper ">
          <div className=" mt-2">
            <Row className="g-3">
              <Col md={2} className="invoicemanagme_box">
                <Card
                  className={`h-100 todocard3 ${activeCard === "Generated" ? "active" : ""}`}
                  style={{
                    backgroundColor: "#F4F8FE",
                    borderRadius: "5px",
                    border: "1px solid #0092D5",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    handleCardClick(INVOICE_REPORTS_CODES.GENERATE);
                    setActiveCard("Generated");
                  }}
                >
                  <Card.Body className="d-flex flex-column justify-content-between p-1">
                    <div className="d-flex justify-content-between align-items-center">
                      <Card.Title
                        style={{
                          color: "#0092D5",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Generated
                      </Card.Title>
                      <span
                        className="material-symbols-outlined"
                        style={{ color: "#0092D5" }}
                      >
                        receipt_long
                      </span>
                    </div>

                    <div className="d-flex justify-content-start forTwoSection ">
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCardClick(INVOICE_REPORTS_CODES.GENERATE);
                          setActiveCard("Generated");
                        }}
                        style={{
                          borderRight: "1px solid transparent",
                          padding: "0px 10px 0px 0px",
                          flex: 1,
                          paddingRight: "14px",
                          background:
                            "linear-gradient(to bottom, transparent 10%, #0092D5 10%, #0092D5 90%, transparent 90%) right / 1px 100% no-repeat",
                          cursor: "pointer",
                        }}
                        className={`px-1 countwrap `}
                      >
                        <div style={{ fontSize: "11px", color: "#0092D5" }}>
                          Count
                        </div>
                        <div
                          style={{
                            fontSize: "15px",
                            color: "#0092D5",
                            fontWeight: "600",
                          }}
                        >
                          {totalGeneratedInvoiceCount}
                        </div>
                      </div>

                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCardClick(INVOICE_REPORTS_CODES.GENERATE);
                          setActiveCard("Generated");
                        }}
                        style={{
                          padding: "0px 10px 0px 10px",
                          cursor: "pointer",
                          flex: 1,
                          paddingRight: "14px",
                        }}
                        className={`px-1 `}
                      >
                        <div style={{ fontSize: "11px", color: "#0092D5" }}>
                          Amount
                        </div>
                        <div
                          style={{
                            fontSize: "15px",
                            color: "#0092D5",
                            fontWeight: "600",
                          }}
                        >
                          ${totalGeneratedInvoiceValue}
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={2} className="invoicemanagme_box">
                <Card
                  className={`h-100 todocard2 ${activeCard === "Amended" ? "active" : ""}`}
                  style={{
                    backgroundColor: "#FCECBE",
                    borderRadius: "5px",
                    border: "1px solid #E6C872",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    handleCardClick(INVOICE_REPORTS_CODES.AMENDED);
                    setActiveCard("Amended");
                  }}
                >
                  <Card.Body className="d-flex flex-column justify-content-between p-1">
                    <div className="d-flex justify-content-between align-items-center">
                      <Card.Title
                        style={{
                          color: "#9b6d15",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Amended
                      </Card.Title>
                      <span
                        className="material-symbols-outlined"
                        style={{ color: "#9b6d15" }}
                      >
                        notes
                      </span>
                    </div>

                    <div className="d-flex justify-content-start forTwoSection ">
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCardClick(INVOICE_REPORTS_CODES.AMENDED);
                          setActiveCard("Amended");
                        }}
                        style={{
                          borderRight: "1px solid transparent",
                          padding: "0px 10px 0px 0px",
                          flex: 1,
                          paddingRight: "14px",
                          background:
                            "linear-gradient(to bottom, transparent 10%, #9b6d15 10%, #9b6d15 90%, transparent 90%) right / 1px 100% no-repeat",
                          cursor: "pointer",
                        }}
                        className={`px-1 countwrap sub-section-1`}
                      >
                        <div style={{ fontSize: "11px", color: "#9b6d15" }}>
                          Count
                        </div>
                        <div
                          style={{
                            fontSize: "15px",
                            color: "#9b6d15",
                            fontWeight: "600",
                          }}
                        >
                          {totalAmendedInvoiceCount}
                        </div>
                      </div>

                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCardClick(INVOICE_REPORTS_CODES.AMENDED);
                          setActiveCard("Amended");
                        }}
                        style={{
                          padding: "0px 10px 0px 10px",
                          cursor: "pointer",
                          flex: 1,
                          paddingRight: "14px",
                        }}
                        className={`px-1 `}
                      >
                        <div style={{ fontSize: "11px", color: "#9b6d15" }}>
                          Amount
                        </div>
                        <div
                          style={{
                            fontSize: "15px",
                            color: "#9b6d15",
                            fontWeight: "600",
                          }}
                        >
                          ${totalAmendedInvoiceValue}
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={2} className="invoicemanagme_box">
                <Card
                  className={`h-100  cancelledArea ${activeCard === "Cancelled" ? "active" : ""}`}
                  style={{
                    backgroundColor: "#E8E8E8",
                    borderRadius: "5px",
                    border: "1px solid #99999C",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    handleCardClick(INVOICE_REPORTS_CODES.CANCELED);
                    setActiveCard("Cancelled");
                  }}
                >
                  <Card.Body className="d-flex flex-column justify-content-between p-1">
                    <div className="d-flex justify-content-between align-items-center">
                      <Card.Title
                        style={{
                          color: "#99999C",
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Canceled
                      </Card.Title>
                      <span
                        className="material-symbols-outlined"
                        style={{ color: "#99999C" }}
                      >
                        question_mark
                      </span>
                    </div>

                    <div className="d-flex justify-content-start forTwoSection ">
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCardClick(INVOICE_REPORTS_CODES.CANCELED);
                          setActiveCard("Cancelled");
                        }}
                        style={{
                          borderRight: "1px solid transparent",
                          padding: "0px 10px 0px 0px",
                          flex: 1,
                          paddingRight: "14px",
                          background:
                            "linear-gradient(to bottom, transparent 10%, #99999C 10%, #99999C 90%, transparent 90%) right / 1px 100% no-repeat",
                          cursor: "pointer",
                        }}
                        className={`px-1 countwrap sub-section-1`}
                      >
                        <div style={{ fontSize: "11px", color: "#99999C" }}>
                          Count
                        </div>
                        <div
                          style={{
                            fontSize: "15px",
                            color: "#99999C",
                            fontWeight: "600",
                          }}
                        >
                          {totalCancelledInvoiceCount}
                        </div>
                      </div>

                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCardClick(INVOICE_REPORTS_CODES.CANCELED);
                          setActiveCard("Cancelled");
                        }}
                        style={{
                          padding: "0px 10px 0px 10px",
                          cursor: "pointer",
                          flex: 1,
                          paddingRight: "14px",
                        }}
                        className={`px-1 `}
                      >
                        <div style={{ fontSize: "11px", color: "#99999C" }}>
                          Amount
                        </div>
                        <div
                          style={{
                            fontSize: "15px",
                            color: "#99999C",
                            fontWeight: "600",
                          }}
                        >
                          ${totalCancelledInvoiceValue}
                        </div>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            <div
              className="my-3"
              style={{ background: "#0092D5", height: "3px" }}
            ></div>
          </div>
          <div className="main_wrapper_section pills_wrapper fixed_headerOnscroll">
            <div className="mt-3 mb-3 invoiceManageWrapper">
              <div className="row">
                <div className="col-md-3 col-xxl-4">
                  <Tabs
                    activeKey={activeTab}
                    onSelect={handleTabChange}
                    className="fade-in-left"
                  >
                    {tabConfigs.map((tab) => (
                      <Tab key={tab.key} eventKey={tab.key} title={tab.title} />
                    ))}
                  </Tabs>
                </div>
                <div className="col-md-9 col-xxl-8">
                  <Row className="justify-content-end g-1 adjustHeight50">
                    <Col sm={4} md={2} className="mt-2">
                      <FloatingLabelMonthPicker
                        label="Billing Month"
                        value={month}
                        onChange={(value) => {
                          setMonth(value);
                          resetAllData();
                        }}
                      />
                    </Col>

                    <Col
                      sm={4}
                      md={3}
                      className="selection_dropdown mt-4 invoice_data"
                    >
                      <DropdownWithTooltip value={teams} options={teamsOptions}>
                        <SearchableSingleSelectDropdown
                          label="Team / Client"
                          name="TeamClient"
                          options={teamsOptions}
                          value={teams}
                          onChange={(e, name, value) => {
                            setTeams(value);
                            const selectedTeam = teamsOptions.find(
                              (option) => option.value === value,
                            );

                            const teamId = selectedTeam?.teamId || null;
                            setTeamClient(teamId);
                            resetAllData();
                          }}
                        />
                      </DropdownWithTooltip>
                    </Col>
                    <Col sm={4} md={3} className="mt-3">
                      <InputGroup className="w-auto px-2">
                        <InputGroup.Text className="px-2">
                          <span className="material-symbols-outlined text-black-50">
                            search
                          </span>
                        </InputGroup.Text>
                        <Form.Control
                          ref={inputRef}
                          aria-label="Search"
                          onChange={(e) =>
                            handleInputChange(e.target.value.trim())
                          }
                          onPaste={(e) => {
                            e.preventDefault();
                            const text = e.clipboardData.getData("text").trim();
                            handleInputChange(text);
                            if (inputRef.current) inputRef.current.value = text;
                          }}
                        />
                      </InputGroup>
                    </Col>
                    <Col sm={0} md={2} className="mt-3">
                      <div className="px-0">
                        <Button
                          className="d-flex align-items-center"
                          style={{
                            background: "none",
                            border: "none",
                            padding: "10px",
                            fontSize: "22px",
                          }}
                          onClick={handleResetFilters}
                        >
                          <span className="material-icons reset_ic0">
                            restart_alt
                          </span>
                        </Button>

                        <span>
                          <AppointmentActionsDropdown
                            name="Actions"
                            options={allOptions}
                            value={selectedAction}
                            onChange={handleActionChange}
                            disabled={
                              !selectedRows || selectedRows?.length === 0
                            }
                            forInvoice={true}
                          />
                        </span>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
          <div style={{ marginBottom: " 40px" }}>
            {configurationAccordion([
              {
                title: "List",
                content: (
                  <>
                    <InvoiceReportDataTable
                      key={tableKey}
                      headers={getHeaders()}
                      filterPayload={{
                        yearMonth: toYearMonth(month),

                        teamId: Number(teamclient) || null,
                        searchText: searchQuery?.trim(),
                        invoiceStatus: activeCard,
                      }}
                      activeTab={activeTab}
                      clientInvoiceData={getCurrentInvoiceData()}
                      getInvoiceByClientQme={getListApi()}
                      getChildUser={getDetailApi()}
                      onRowSelect={handleRowSelect}
                      onAction={handleAction}
                      selectedRowIds={selectedRows
                        ?.map((row) => row?.id)
                        .filter(Boolean)}
                      resetTrigger={resetTableTrigger}
                      isLoader={loading}
                      activeCardDisable={
                        activeCard === "Cancelled" || activeCard === "Amended"
                      }
                    />
                  </>
                ),
              },
            ])}
          </div>
        </div>
      </Container>
      {showActionDrawer && (
        <InvoiceCancel
          show={showActionDrawer}
          onHide={handlecloseActionDrawer}
          selectedLineItem={selectedRows}
          clientInvoiceSummaries={nestedRowsData}
          drawerTitle={drawerTitle}
          activeTab={activeTab}
        />
      )}
    </>
  );
};

export default InvoiceReportDashboard;
